import _ from 'lodash';

const countries = {
  dk: 'denmark'
};

/*
  This code reads segments stored by krux in localstorage and then saves it in
  a generic object on window that's later used in ad requests
*/
export default function(countryCode) {
  const tracking = {};
  const country = countries[countryCode];

  if (country && localStorage) {
    tracking.country = country;
    const segs = localStorage.getItem('kxmtg' + country + '_segs');
    if (segs) {
      tracking.segments = _.map(segs.split(','), segment => 'kxseg_' + segment);
    }
  }

  window.playStorage = window.playStorage || {};
  window.playStorage.data = {
    tracking,
  };
}



// WEBPACK FOOTER //
// ./src/util/extractKruxData.js